/*
Used to cancel previous fetch request if new request is made
For detailed description - https://developer.mozilla.org/en-US/docs/Web/API/AbortController
*/
var abortControllerClass = /** @class */ (function () {
    function abortControllerClass(abortController) {
        this.abortController = abortController;
    }
    return abortControllerClass;
}());
export default abortControllerClass;
